import { render, staticRenderFns } from "./rp-attr-filter-content-tabs.vue?vue&type=template&id=0d23f5f4"
import script from "./rp-attr-filter-content-tabs.vue?vue&type=script&lang=js"
export * from "./rp-attr-filter-content-tabs.vue?vue&type=script&lang=js"
import style0 from "./rp-attr-filter-content-tabs.vue?vue&type=style&index=0&id=0d23f5f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports